import InProgressStatus from '~/assets/status/icon_andamento.png';
import LateStatus from '~/assets/status/icon_atrasado.png';
import CancelledStatus from '~/assets/status/icon_cancelado.png';
import FinishedLateStatus from '~/assets/status/icon_concluido_atraso.png';
import FinishedStatus from '~/assets/status/icon_concluido.png';
import AvailableStatus from '~/assets/status/icon_disponivel.png';

export enum ProcessStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  EXTERNALLY_TERMINATED = 'EXTERNALLY_TERMINATED',
  INTERNALLY_TERMINATED = 'INTERNALLY_TERMINATED',
}

export const getStatusImageAndLabel = (status?: string) => {
  const formattedStatus = status?.toUpperCase();
  switch (formattedStatus) {
    case ProcessStatus.COMPLETED:
      return { image: FinishedStatus, name: 'Concluído' };
    case ProcessStatus.EXTERNALLY_TERMINATED:
      return { image: CancelledStatus, name: 'Cancelado' };
    case ProcessStatus.INTERNALLY_TERMINATED:
      return { image: CancelledStatus, name: 'Cancelado' };
    default:
      return { image: InProgressStatus, name: 'Em andamento' };
  }
};

export enum TaskStatus {
  AVAILABLE = 'AVAILABLE',
  IN_PROGRESS = 'IN_PROGRESS',
  LATE = 'LATE',
  DELETED = 'DELETED',
  COMPLETED = 'COMPLETED',
  COMPLETED_LATE = 'COMPLETED_LATE',
}

export const getTaskStatusImageAndLabel = (status?: string) => {
  const formattedStatus = status?.toUpperCase();
  switch (formattedStatus) {
    case TaskStatus.IN_PROGRESS:
      return { image: InProgressStatus, name: 'Em andamento' };
    case TaskStatus.LATE:
      return { image: LateStatus, name: 'Atrasada' };
    case TaskStatus.COMPLETED:
      return { image: FinishedStatus, name: 'Concluída' };
    case TaskStatus.COMPLETED_LATE:
      return { image: FinishedLateStatus, name: 'Concluída com atraso' };
    case TaskStatus.DELETED:
      return { image: CancelledStatus, name: 'Cancelada' };
    default:
      return { image: AvailableStatus, name: 'Disponível' };
  }
};
